import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError, take } from 'rxjs/operators';
import { IHttpErrorPayload, HttpRequestPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from 'src/app/core/services/http-provider/http-provider.service';
import { ITransactionSearchModel, ITransactionSearchResponseModel } from '../models/transaction-search.model';
import { RetailStock } from 'src/app/retail-common.service';
import { AccountsService } from 'src/app/services/accounts/accounts.service';
import { FileOpenerService } from 'src/app/services/mobile/file-opener.service';
import { CommonService } from 'src/app/common.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionSearchService {

  constructor(
    private _httpProvider : HttpProviderService, 
    private _fileOpner:FileOpenerService,
    private _commonService:CommonService
  ) { }

  transactionSearch(payload: ITransactionSearchModel): Observable<ITransactionSearchResponseModel> {
    const httpRequest : HttpRequestPayload = {
      resource : `/transaction/${payload.accountNumber}`,
      method : "GET",
      headerParams: [
        {key:'fromDate',value: payload.fromDate },
        {key:'toDate',value: payload.toDate },
        {key:'month',value: payload.month },
        {key:'year',value: payload.year },
        {key:'noOfTransactions',value: '20' },
        {key:'filterType',value: payload.transPeriod },
      ]
    }
    return this._httpProvider.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      // response.body.transaction[0].transactionDesc = 'Mohan';
      const transactionSearchResponse : ITransactionSearchResponseModel = {
        httpStatus : response.status,
        inventoryNo : response.body?.transaction?.inventoryNumber,
        transaction: response.body?.transaction
      }
      return transactionSearchResponse
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
  transactionDownload(payload: ITransactionSearchModel) {
    const httpRequest : HttpRequestPayload = {
      resource : `/statementdownload`,
      method : "GET",
      queryParams: [
        {key:'fromDate',value: payload.fromDate },
        {key:'toDate',value: payload.toDate },
        {key:'month',value: payload.month },
        {key:'year',value: payload.year },
        {key:'noOfTransactions',value: '20' },
        {key:'accountNumber',value: payload.accountNumber }
      ],
      headerParams: [
        {key:'filterType',value: payload.transPeriod },
      ]
    }
    this._commonService.showSpinner();
    return this._httpProvider.invokeDownloadApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      this._commonService.hideSpinner();
      if(this._commonService.isHybrid()){
        this._fileOpner.openPDF(response, 'application/pdf', 'AccountStatement.pdf');
      } else {
        let documentURL = URL.createObjectURL(new Blob([response.body], { type: 'application/pdf' }));
        const downloadLink = document.createElement('a');
        downloadLink.href = documentURL;
        const fileName = 'AccountStatement';
        downloadLink.download = fileName;
        downloadLink.click();
      }
      return null;
    },
    catchError((err : IHttpErrorPayload) => { 
      this._commonService.hideSpinner();
      return throwError(err)
    })));
  }
}
